export const siteData = {
  company: {
    name: 'Floret Town',
    tagline: 'A Township Where Life Naturally Blooms',
    parentCompany: 'FB Group',
    parentWebsite: 'https://fbgroupinfra.com'
  },
  contact: {
    phone: '18003137074',
    mobile: '+91-9511115435',
    whatsapp: '+91-9511115435',
    siteAddress: 'Outer Ring Road (Kisan Path) near the Lucknow-Ayodhya highway',
    officeAddress: {
      line1: 'NH27, Floret Tower, 1st Floor',
      line2: 'Opposite Mercedes Benz Showroom',
      line3: 'Near By Hero Bike Showroom',
      line4: 'Tiwariganj, Lucknow'
    }
  },
  navigation: [
    { id: 'home',path:'/', label: 'Home' },
    { id: 'project',path:'/project', label: 'Projects' },
    { id: 'gallery',path:'/gallery', label: 'Gallery' },
    { id: 'location',path:'/location', label: 'Location' },
    { id: 'contact',path:'/contact', label: 'Contact' }
  ],
  pillars: [
    {
      title: 'Green Living',
      description: 'Lush landscapes & open spaces for peaceful refreshing everyday life',
      icon: 'Leaf'
    },
    {
      title: 'Fresh Fragrance',
      description: 'Clean air, calm surroundings, and a naturally soothing environment that hits different',
      icon: 'Wind'
    },
    {
      title: 'Flowers & Blooming Life',
      description: 'Beautiful gardens and a vibrant community where families grow and celebrate',
      icon: 'Flower'
    }
  ],
  highlights: [
    { icon: 'Home', title: 'Premium Villas', desc: 'Thoughtfully designed modern villas for comfortable family living' },
    { icon: 'Sunrise', title: 'Lifestyle Promise', desc: 'Peaceful township living with all essential urban comforts' },
    { icon: 'MapPin', title: 'Location Advantage', desc: 'Well-connected close to schools, hospitals, and daily needs' },
    { icon: 'ShieldCheck', title: 'Trust & Planning', desc: 'Secure, well-planned township built for long-term value' }
  ],
  villaTypes: [
    "80' × 140' Luxury Villa",
    "55' × 80' Premium Villa",
    "45' × 80' Premium Villa",
    "35' × 70' Villa",
    "30' × 60' Villa",
    "30' × 50' Villa",
    "25' × 50' Villa",
    "25' × 45' Villa",
    "22.5' × 45' Villa",
    "Not Sure / Need Guidance"
  ]
};